import axios from './apiClient/axios'
import Vue from 'vue'
import store from '../stores/index'
const BACKEND_URL = process.env.BACKEND_URL
const STAFF_URL = process.env.BACKEND_URL + 'staff/'
const settings = new Vue({
    beforeCreate() {
        axios.defaults.withCredentials = true
    },
    methods: {
        getSubjectList() {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/subjects/`
            return axios.get(url).then(response => response.data)
        },
        async getPremiumStatus() {
            const settings = await this.getAllSettings()
            return settings.premiumTime > new Date().getTime()
        },
        async getAllSettings(guildId = store.getters.staffGuild) {
            const url = `${STAFF_URL}${guildId}/settings`
            const settings = (await axios.get(url)).data
            let perm = settings.ticketPermission
            perm.users.allowed = BigInt(perm.users.allowed)
            perm.users.denied = BigInt(perm.users.denied)
            perm.staff.allowed = BigInt(perm.staff.allowed)
            perm.staff.denied = BigInt(perm.staff.denied)
            return settings
        },
        updateSetting(name, value) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/update`
            return axios
                .post(url, { name: name, value: value }, { headers: { 'Content-Type': 'application/json;charset=utf-8' } })
                .then(response => response.data)
        },
        createSubject(name, copyFrom) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/subjects/createsubject`
            return axios.post(url, { name: name, copyFrom: copyFrom }).then(response => response.data)
        },
        getSubject(subjectId, categoryId) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/subjects/${subjectId}?categoryId=${categoryId}`
            return axios.get(url).then(response => response.data)
        },
        deleteSubject(subjectId, categoryId) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/subjects/deletesubject`
            return axios.post(url, { subjectId: subjectId, categoryId: categoryId }).then(response => response.data)
        },
        updateSubject(newSubject, categoryId) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/subjects/updatesubject`
            return axios.post(url, { subject: newSubject, categoryId: categoryId }).then(response => response.data)
        },
        createCategory(name) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/categories/createcategory`
            return axios.post(url, { name: name }).then(response => response.data)
        },
        deleteCategory(id) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/categories/deletecategory`
            return axios.post(url, { id: id }).then(response => response.data)
        },
        updateCategoryOrder(move) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/categories/updatecategoryorder`
            return axios.post(url, { move: move }).then(response => response.data)
        },
        changeSubjectCategory(move) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/subjects/changecategory`
            return axios.post(url, { move: move }).then(response => response.data)
        },
        updateSubjectOrder(move) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/subjects/updatesubjectorder`
            return axios.post(url, { move: move }).then(response => response.data)
        },
        updateCategory(category) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/categories/updatecategory`
            return axios.post(url, { category: category }).then(response => response.data)
        },
        createOrUpdatePrequestion(question, id, subjectId, categoryId) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/prequestions/`
            return axios
                .post(url, { template: question, id: id, subjectId: subjectId, categoryId: categoryId })
                .then(response => response.data)
        },
        updateQuestionOrder(move, subjectId, categoryId) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/prequestions/move`
            return axios.post(url, { move: move, subjectId: subjectId, categoryId: categoryId }).then(response => response.data)
        },
        deletePrequestion(id, subjectId, categoryId) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/prequestions/delete/${id}`
            return axios.post(url, { subjectId: subjectId, categoryId: categoryId }).then(response => response.data)
        },
        sendPanel(panel) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/panel/send`
            return axios.post(url, { panel: panel }).then(response => response.data)
        },
        getPanels() {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/panel`
            return axios.get(url).then(response => response.data)
        },
        deletePanel(panelId) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/panel/delete`
            return axios.post(url, { id: panelId }).then(response => response.data)
        },
        importQuestions(fromCategory, toCategory, fromSubject, toSubject) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/prequestions/import`
            return axios
                .post(url, {
                    fromCategory: fromCategory,
                    toCategory: toCategory,
                    fromSubject: fromSubject,
                    toSubject: toSubject,
                })
                .then(response => response.data)
        },
        importStaffRoles(fromCategory, toCategory, fromSubject, toSubject) {
            const url = `${STAFF_URL}${store.getters.staffGuild}/settings/subjects/importstaffroles`
            return axios
                .post(url, {
                    fromCategory: fromCategory,
                    toCategory: toCategory,
                    fromSubject: fromSubject,
                    toSubject: toSubject,
                })
                .then(response => response.data)
        },
    },
})

export default {
    install: function(Vue) {
        Vue.prototype.$settings = settings
    },
}



// WEBPACK FOOTER //
// ./src/api/settings.js